export default {
  AuditTrailStarted: 'AuditTrailStarted',
  StatementRecalculated: 'StatementRecalculated',
  CommissionInsertedIntoStatement: 'CommissionInsertedIntoStatement',
  CommissionOverrideAltered: 'CommissionOverrideAltered',
  EmailSent: 'EmailSent',
  EmailReSent: 'EmailReSent'
}
